import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDrugsGebruiken = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M16.824 9.966a5 5 0 0 0-9.61 2.77L12.2 30.03a5 5 0 1 0 9.61-2.77z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m9.39 23.152 1.5 5.22a4.5 4.5 0 0 0 5.572 3.078l.276.96a5.5 5.5 0 0 1-6.808-3.762l-1.5-5.22z"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="m9.7 21.38-2.49-8.64a5 5 0 0 1 3.42-6.19A5 5 0 0 1 16.82 10l2.49 8.65M28 28.62A6.31 6.31 0 1 0 28 16a6.31 6.31 0 0 0 0 12.62"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m33.999 24.325-12.24-3.06.242-.97 12.24 3.06z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M23 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2M26.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M24.5 14a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDrugsGebruiken);

export default ForwardRef;
